

jQuery(document).ready(function () {

	set_banner_placeholder_height();
	set_banner_header_spacing();
	set_mega_menu_spacing();
	
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 2) {
			set_banner_header_spacing();
			set_mega_menu_spacing();
        } else {
            jQuery('.header-block:not(.transparent)').css('padding-top', 0);
        }
    });

    jQuery(window).on("resize", function () {
		set_banner_header_spacing();
		set_banner_placeholder_height();
		set_mega_menu_spacing();
    });
});

set_banner_placeholder_height = function () {
    if (jQuery('.banners-placeholder').length) {
        setTimeout(function () {
            jQuery('.banners-placeholder').height(jQuery(".header-banners-container .header-banners").height());
        }, 200);
    }
}

set_banner_header_spacing = function () {

    if (jQuery('.header-banners-container').length) {
		if (jQuery('.header-block').hasClass('transparent')) {
			setTimeout(function () {
				jQuery('body').css('padding-top', jQuery('.header-banners-container .header-banners').height());
			}, 200);
            //jQuery('.header-block').css('padding-top', jQuery('.header-banners-container .header-banners').height());
        } else {jQuery('.header-block.scrolling').css('padding-top', jQuery('.header-banners-container .header-banners').height());
        }
	}

}

set_mega_menu_spacing = function () {

	if (jQuery('.header-banners-container').length) {
		if (jQuery('.header-block').hasClass('transparent')) {

			var header_height = jQuery('.header-block .header-outer-container').height();
			var wp_admin_bar_height = 0;
			var header_banner_height = 0;

			if (jQuery('.header-banners-container .header-banners').length) {
				var header_banner_height = jQuery('.header-banners-container .header-banners').height();
			}
        
			if (jQuery('#wpadminbar').length) {
				if (jQuery(window).width() > 782) {
					wp_admin_bar_height = 32;
				} else {
					wp_admin_bar_height = 46;
				}
			}

        // Set top for .sub-nav-container-outer
			
			jQuery('.sub-nav-container-outer').css('top', (header_height + wp_admin_bar_height) + 'px');
			jQuery('.sub-nav-container-outer.scrolling').css('top', (header_height + wp_admin_bar_height) + 'px');

			jQuery('.logged-in .sub-nav-container-outer').css('top', (header_height) + 'px');
			jQuery('.logged-in .sub-nav-container-outer.scrolling').css('top', (header_height) + 'px');
        
        // Set top for .logged-in .header-block
		jQuery('.header-block').css('top', (header_banner_height + wp_admin_bar_height) + 'px');
			
		// Set top for .logged-in .scrolling .header-block
		jQuery('.header-block.scrolling').css('top', (header_banner_height + wp_admin_bar_height) + 'px');
			
    }
}

}


/// Language banner

jQuery(document).ajaxComplete(function (event, request, settings) {

    const lang_box = jQuery('.banner-langs-select .lang-box');
    const lang_box_list = jQuery('.banner-langs-select .lang-box-list');
    const lang_box_list_li = jQuery('.banner-langs-select .lang-box-list li');

    lang_box.on('click', function () {
        if (lang_box.hasClass('active')) {
            lang_box.removeClass('active');
        } else {
            lang_box.addClass('active');
        }
    });

    lang_box_list_li.on('click', function () {
        var url = jQuery(this).attr('data-url');
        var name = jQuery(this).attr('data-name');
        lang_box.attr('data-url', url);
        lang_box.find('span.text').text(name);
        lang_box.removeClass('active');
    });

    jQuery('.banner-langs-select #continue').on('click', function () {
        $redirect_url = lang_box.attr('data-url');
        window.location.href = $redirect_url;
        //setLangBannerSession($redirect_url);
    });

    jQuery('.banner-langs-select #close').on('click', function () {
        jQuery('.banner-langs-select').remove();
		set_banner_header_spacing();
		set_mega_menu_spacing();
        set_banner_placeholder_height();
        setLangBannerSession();
    });
});


function setLangBannerSession($redirect_url = '') {
    jQuery.ajax({
        type: "POST",
        dataType: 'json',
        url: ajax_marketing_theme.ajaxurl,
        data: {
            action: "banner_set_session",
        },
        success: function (data) {
        }
    });
}